<div class="insurance-documents-component">
  <document-details
    [application]="application"
    [apiUrl]="apiUrl"
    [listApplicationDocumentFn]="listApplicationDocumentFn"
    [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
    [approveApplicationDocumentFn]="approveApplicationDocumentFn"
    [declineApplicationDocumentFn]="declineApplicationDocumentFn"
    [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
    [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
    [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
    [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
    [undoApplicationDocumentFn]="undoApplicationDocumentFn"
    [createDocumentWorklistFn]="createDocumentWorklistFn"
    [completeDocumentWorklistFn]="completeDocumentWorklistFn"
    [getUserFn]="getUserFn"
    [getUserByAccessLevelFn]="getUserByAccessLevelFn"
    (scrollEvent)="scrollToChildTwo()"
    (events)="onDocumentDetailsEvent($event)"
    (saveNote)="onSaveNote()"
    [getApplicationByIdFn]="getApplicationByIdFn"
    [generateApprovalNoticeFn]="generateApprovalNoticeFn"
    [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
    [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
    [updateApplicationStageFn]="updateApplicationStageFn"
    [getApplicationAssetFn]="getApplicationAssetFn"
    [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
    [settleLoanFn]="settleLoanFn"
    [totalNotesCount]="totalNotesCount"
  ></document-details>

  <div class="notes">
    <asset-notes
      #assetNotesComponent
      [application]="application"
      [createDocumentWorklistFn]="createDocumentWorklistFn"
      [completeDocumentWorklistFn]="completeDocumentWorklistFn"
      [isAssetNoteEditorShow] = "false"
      [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
      [createApplicationNoteFn]="createApplicationNoteFn"
      [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      (totalNotesEvent)="totalNotes($event)"
    ></asset-notes>
  </div>
</div>
